// theme constant
export const gridSpacing = 2;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

export const rankColorOwner = "#62b3ff";
export const rankColorAdmin = "#9b6dfd";
export const rankColorMember = "#e6a141";
export const rankColorAssociate = "#90c817";
